import React from 'react';
import './map-button.css';
export const SimpleLayerButton = ({ label, state = 'disabled', onClick, comingSoon = false, }) => {
    // Coming-soon layers use the same purple disabled look as other off layers
    const visualState = comingSoon ? 'disabled' : state;
    return (React.createElement("div", { className: `map-button simple-layer ${visualState}-state` },
        React.createElement("button", { className: "btn btn-outline btn-outline-dark", type: "button", onClick: onClick }, label)));
};
